// @flow

import { connect } from 'react-redux';
import { fetchContentful } from 'client/actions/contentful';
import HealthGuidePage from './healthGuidePage';

const mapStateToProps: Object = state => ({
  contentfulData: state.contentfulData,
});

export default connect(mapStateToProps, { fetchContentful })(HealthGuidePage);
